import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
  ADD_NEW_GASS,
  DELETE_GASS,
  GASS_FORM_TOOGLE_LOADING,
  SET_GASS_LIST,
  SHOW_NOTIFICATION,
  UPDATE_GASS,
} from "../constants";
import { formatGass } from "./settingsActionsUtils";

/* GASS LIST */
export const fetchGass = () => {
  return async (dispatch) => {
    const response = await axios
      .get(API.gass.list)
      .then((response) => {
        const gass = formatGass(response.data);
        dispatch({ type: SET_GASS_LIST, payload: keyBy(gass, "_id") });
        return response.status;
      })
      .catch((err) => err);
    return response;
  };
};

// GASS
export const createGass = (newGass) => {
  return async (dispatch) => {
    dispatch({ type: GASS_FORM_TOOGLE_LOADING });
    const response = await axios
      .post(API.gass.create, newGass)
      .then((response) => {
        const gass = formatGass(response.data);
        dispatch({ type: ADD_NEW_GASS, payload: gass });
        dispatch({ type: GASS_FORM_TOOGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "success",
            message: "Gasto creado con éxito.",
          },
        });
        return response.status;
      })
      .catch((err) => {
        dispatch({ type: GASS_FORM_TOOGLE_LOADING });
        return err;
      });
    return response;
  };
};

export const updateGass = (updatedGass) => {
  return async (dispatch) => {
    dispatch({ type: GASS_FORM_TOOGLE_LOADING });
    const response = await axios
      .put(`${API.gass.edit}${updatedGass._id}`, updatedGass)
      .then((response) => {
        const gass = formatGass(response.data);
        dispatch({ type: UPDATE_GASS, payload: gass });
        dispatch({ type: GASS_FORM_TOOGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "info",
            message: "Gasto actualizado.",
          },
        });
        return response.status;
      })
      .catch((err) => {
        dispatch({ type: GASS_FORM_TOOGLE_LOADING });
        return err;
      });
    return response;
  };
};

export const deleteGass = (Ids) => {
  return async (dispatch) => {
    dispatch({ type: GASS_FORM_TOOGLE_LOADING });
    const response = await axios
      .delete(`${API.gass.delete}`, { data: Ids })
      .then((response) => {
        dispatch({ type: DELETE_GASS, payload: Ids });
        dispatch({ type: GASS_FORM_TOOGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "info",
            message: "Gastos eliminados. ",
          },
        });
        return response.status;
      })
      .catch((err) => {
        dispatch({ type: GASS_FORM_TOOGLE_LOADING });
        return err;
      });
    return response;
  };
};
